<template>
  <div class="meun">
    <div class="header">
      <el-button type="primary" size="small" @click="addOta()">添加</el-button>
      <el-button type="primary" size="small" @click="dialogVisible1()">批量删除</el-button>

      <!-- 添加 -->
      <el-dialog title="添加内容" :visible.sync="dialogFormVisible" :before-close="handleClose" fullscreen>
        <div style="margin-top: -30px;">
          <div class="page1">
            <!-- 1 -->
            <el-form ref="form" :model="form" label-width="80px">
              <el-form-item label="版本类型" size="small" style="width: 480px;">
                <el-radio-group v-model="form.versionType" @change="updatedVersion(radio)">
                  <el-radio label="1">差分包</el-radio>
                  <el-radio label="2">全量包</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="APP key">
                <el-select v-model="form.appkey" filterable placeholder="请选择" style="width: 400px;" size="small"
                  @change="versionTypeChange">
                  <el-option v-for="item in optionsAppKey" :key="item.appkey" :label="item.appkey" :value="item.appkey"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="终端类型">
                <el-select v-model="form.terminalType" placeholder="请选择" style="width: 400px;" size="small">
                  <el-option v-for="item in terminalList" :key="item.name" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="版本名称" size="small" style="width: 480px;">
                <el-input v-model="form.versionName"></el-input>
              </el-form-item>

              <el-form-item label="待升版本" v-if="hide" size="small" style="width: 480px;">
                <el-input v-model="form.exversionName"></el-input>
              </el-form-item>

              <el-form-item label="上传文件" size="small" style="width: 480px;">
                <el-upload class="upload-demo" :action=uploadUrl :on-change="handleChange" :file-list="fileList"
                  :on-success="handleAvatarSuccess" multiple :limit="1">
                  <el-button size="small" type="primary" style="width: 400px;" limit="1">上传文件</el-button>
                  <div slot="tip" class="el-upload__tip">请上传的文件不超过30M</div>

                </el-upload>
              </el-form-item>
              <div>上传文件URL:{{fileUrl}}</div>
            </el-form>
          </div>
          <div class="page2">
            <el-form ref="form" :model="form" label-width="80px">
              <el-form-item label="文件Hash" size="small" style="width: 480px;">
                <el-input v-model="form.fileHash"></el-input>
              </el-form-item>
              <el-form-item label="版本信息" size="small" style="width: 480px;">
                <el-input v-model="form.versionDesc"></el-input>
              </el-form-item>
              <el-form-item label="生效时期" size="small" style="width: 480px;">
                <el-date-picker v-model="form.effectiveDate" type="datetime" placeholder="选择日期时间" style="width: 400px;"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
              <el-form-item label="发布说明">
                <el-input type="textarea" v-model="form.publishDesc" style="width: 400px;"></el-input>
              </el-form-item>

              <!-- <el-form-item label="串号列表" size="small">
								<el-select v-model="form.sn" multiple filterable allow-create default-first-option placeholder="请选择"  size="small" style="width: 400px;">
									<el-option v-for="item in options1" :key="item.serialNoId" :label="item.sn" :value="item.sn"></el-option>
								</el-select>
							</el-form-item> -->

              <el-form-item label="串号列表" size="small">
                <el-input type="textarea" v-model="form.sn" style="width: 59%;" multiple collapse-tags disabled></el-input>
                <el-button type="primary" size="small" @click="choice()">选择</el-button>
              </el-form-item>
              <el-form-item label="串号升级">
                <el-checkbox v-model="checked" @change="checkedBtn()"></el-checkbox>
              </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancelOta()" size="small">取 消</el-button>
              <el-button type="primary" @click="saveota()" size="small">确 定</el-button>
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- 选择 -->
      <el-dialog title="选择列表" :visible.sync="dialogFormVisible4" width="80%" :close-on-click-modal="false" top="0"
        border>
        <div style='overflow: hidden;'>
          <div class="table_left">
            <el-input class="search" size="small" placeholder="串号搜索" icon="el-icon-eleme" v-model="form.querySertitleName"
              @keyup.enter.native="queryserialno" :on-icon-click="queryserialno" width="100"></el-input>
            <el-button type="primary" size="small" @click="queryserialno()">搜索</el-button>
            <!-- 分页 -->
            <el-pagination style="float: right;" background @size-change="handleCurrentChangeStrand" @current-change="handleCurrentChangeStrand"
              :current-page.sync="form.pageNo" :page-size="form.pageSize" layout="total, prev, pager, next"
              :pager-count="5" :total="form.totalCount">
            </el-pagination>

            <div :style="{height:tableHeight - 240 +'px'}">
              <el-table :maxHeight="tableHeight - 240 + 'px'" size="small" ref="gridData" :data="gridData"
                tooltip-effect="dark" border @selection-change="handleSelectionChangeChoice">

                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column property="sn" label="串号列表"></el-table-column>
              </el-table>
            </div>
          </div>

          <div class="table_right" :style="{height:tableHeight - 200 +'px'}">
            <div style="display:inline-block;position: absolute;top: -53px;">已选内容：</div>
            <transition-group name="right-fade-in" tag="div" class="table_border" :style="{height:tableHeight - 200 +'px'}">
              <div v-for="(sn, index) in contentMultipleSelection " :key="sn">

                <span class="table_right_name">
                  <span class="span">{{sn}}</span>
                  <i class="el-icon-minus shez" @click="remove_multiple_selected_content(sn, index)"></i>
                </span>

              </div>
            </transition-group>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible4 = false" size="small">取 消</el-button>
          <el-button type="primary" @click="Save_choice()" size="small">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="dialogVisible" width="30%">
        <span v-if='ids == 0'>请选择数据</span>
        <p style="margin: 0px;height: 40px; line-height: 44px;" v-if="ids != 0">
          <i class="el-icon-delete-solid" style="font-size: 40px; color:#409EFF;float: left;"></i>
          <span style="float: left;">确定删除吗？</span>
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="delOta()" size="small">确 定</el-button>
        </span>
      </el-dialog>

      <span>ORM包：</span>
      <el-select v-model="searchVersionType" filterable clearable placeholder="请选择" size="small" style="width: 100px;margin-right: 15px;">
      <el-option v-for="item in verionTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
      <span>终端类型：</span>
      <el-input class="search" size="small" placeholder="终端类型搜索" icon="el-icon-eleme" v-model="form.terminalType"
        @keyup.enter.native="queryota" :on-icon-click="queryota"></el-input>
      <span>APP key：</span>
      <el-input class="search" size="small" placeholder="appkey搜索" icon="el-icon-eleme" v-model="form.appkey"
        @keyup.enter.native="queryota" :on-icon-click="queryota"></el-input>

      <el-button type="primary" size="small" @click="queryota()">搜索</el-button>
      <!-- 分页 -->
      <el-pagination class="paging" background @size-change="handleSizeChange" @current-change="handleCurrentChangeParam"
        :current-page.sync="pageNo" :page-size="pageSize" layout="total, prev, pager, next" :pager-count="5" :total="totalSize">
      </el-pagination>

    </div>
    <div :style="{ height: tableHeight + 'px' }" style="margin-right: 10px;">
      <el-table :maxHeight="tableHeight" ref="multipleTable" :data="tableData" tooltip-effect="dark" size="small"
        border @selection-change="multipleSelection = arguments[0]">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column label="orm包类型" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.versionType == verionType.chafen.code">差分包</div>
            <div v-else>全量包</div>
          </template>
        </el-table-column>
        <el-table-column prop="terminalType" label="终端类型" width="100"></el-table-column>
        <el-table-column prop="appKey" label="AppKey" width="120" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="versionName" label="版本名称" width="120" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="exversionName" label="待升版本" width="130" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="fileHash" label="文件hash值" width="120" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="forbidFlag" label="串号升级" width="70" align="center" show-overflow-tooltip></el-table-column> -->

        <el-table-column prop="forbidFlag" label="串号升级" width="70" align="center" show-overflow-tooltip>
          <template scope="scope">
            <div v-if="scope.row.forbidFlag == strand.YES.code">是</div>
            <div v-if="scope.row.forbidFlag == strand.NO.code">不是</div>
          </template>
        </el-table-column>

        <el-table-column prop="fileUrl" label="下载" width="70" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <i class="el-icon-download" title="下载" @click="downLoadFile(scope.row.fileUrl)">
            </i>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="150" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{formatCreateDate(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" show-overflow-tooltip align="center">
          <template scope="scope">
            <el-button type="primary" size="small" @click="editOta(scope.row)">编辑</el-button>
            <!--						<el-button type="primary" size="small" @click="delOta(scope.row.id)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import constants from '@/js/constants.js'
  import {
    mapState
  } from 'vuex';
  import api from '@/api/ota/';
  import appApi from '@/api/menu/'
  //import Logan from 'logan-web';
  //添加一个的类型
  const strand = constants.strand;
  const verionType = {
    chafen: {
      code: 1,
      label: '差分包'
    },
    allpage: {
      code: 2,
      label: '全量包'
    },
  };

  export default {
    computed: {
      ...mapState('main', ['tableHeight'])
    },
    data() {
      return {
        strand,
        gridData: [],
        checked: false,
        options1: [],
        dialogFormVisible4: false,
        dialogVisible: false,
        terminalList: [],
        searchVersionType: '',
        value: '',
        terminalTypeValue: '',
        appkeyValue: '',
        verionType,
        verionTypeOptions: [{
            value: 1,
            label: '差分包'
          },
          {
            value: 2,
            label: '全量包'
          }
        ],
        optionsAppKey: [],
        cdn_token: '',
        token: '',
        uploadUrl: '',
        fileUrl: '',
        // 上传文件
        // tableHeight: window.innerHeight  - 200,
        fileList: [],
        radio: '1',
        hide: true,
        couponSelected: '', //默认选中
        tableData: [],
        multipleSelection: [],
        contentMultipleSelection: [], // 添加内容时已选中的内容
        currentPageCheckedIndexs: [], // 当前页选中的index数组
        dialogFormVisible: false,
        dialogFormVisibleEdit: false,
        pageNo: 1,
        pageSize: 15,
        totalSize: 0,
        ids: [],
        form: {
          'pageNo': 1,
          'pageSize': 15,
          totalCount: 0, //总条数
          sn: '',
          otaId: '',
          versionType: '1',
          terminalType: '',
          appkey: '',
          versionName: '',
          exversionName: '',
          fileHash: '',
          fileUrl: '',
          effectiveDate: '',
          publishDesc: '',
          versionDesc: '',
          forbidFlag: '1',
          serialNos: '',
          querySertitleName: '',
        },
        formLabelWidth: '120px'
      };
    },

    mounted() {
      // console.log(window.getComputedStyle(this.$refs.tablewrap).height)
      // console.log(this.tableHeight)
    },
    methods: {
      addOta() {
        this.dialogFormVisible = true;
        this.contentMultipleSelection = []; // 添加内容时已选中的内容
        this.currentPageCheckedIndexs = []; // 当前页选中的index数组
      },
      remove_multiple_selected_content(sn, index) {
        this.contentMultipleSelection.splice(index, 1);
        // 如果表格中有要删除的这个数据，取消checkbox
        let glIndex = this.gridData.findIndex(val => val.sn === sn);
        if (glIndex !== -1)
          this.$refs.gridData.toggleRowSelection(this.gridData[glIndex], false)
      },
      // 选择
      choice() {
        this.dialogFormVisible4 = true;
        // this.gridData = [];
        this.queryserialno();

      },
      // 选择 确定
      Save_choice() {
        this.dialogFormVisible4 = false;
        let newIndexs = [];
        for (var i = 0; i < this.contentMultipleSelection.length; i++) {
          newIndexs.push(this.contentMultipleSelection[i]);
        }
        this.form.sn = newIndexs.toString();
      },
      handleSelectionChangeChoice: function(contents) {
        let newIndexs = [];
        // 判断已选中列表中是否已经有contents, 没有就加入
        for (let content of contents) {
          let index = this.contentMultipleSelection.findIndex(sn => sn === content.sn);
          newIndexs.push(this.gridData.findIndex((val) => val.sn === content.sn))
          if (index === -1) {
            this.contentMultipleSelection.unshift(content.sn);
          }

        }
        let _this = this
        // 新旧对比，如果旧的有的新的没有，那么就删除这个
        for (let old of _this.currentPageCheckedIndexs) {
          if (newIndexs.findIndex(newIndex => newIndex === old) === -1) {
            let index = _this.contentMultipleSelection.findIndex(sn => sn === _this.gridData[old].sn);
            if (index !== -1) {
              _this.contentMultipleSelection.splice(index, 1)
            }
          }
        }
        _this.currentPageCheckedIndexs = newIndexs;
      },






      checkedBtn() {
        if (this.checked) {
          this.form.forbidFlag = '2';
        } else {
          this.form.forbidFlag = '1';
        }
      },
      // 11.24获取串号信息
      queryserialno() {
        var data = {
          'sn': this.form.querySertitleName,
          'token': this.token,
          'pageNo': this.form.pageNo,
          'pageSize': this.form.pageSize,
        };
        var _this = this;
        appApi.queryserialno(data)
          .then(res => {
            if (res.data.code == 0) {

              this.options1 = res.data.data.list;
              this.gridData = res.data.data.list;
              this.form.totalCount = res.data.data.totalSize;
              this.currentPageCheckedIndexs = [];

              if (_this.form.sn) {
                _this.contentMultipleSelection = _this.form.sn.split(',');
              }

              _this.$nextTick(() => {
                _this.gridData.forEach((data, index) => {
                  if (data && _this.contentMultipleSelection.findIndex(sn => sn === data.sn) !== -1) {
                    _this.$refs.gridData.toggleRowSelection(_this.gridData[index], true)
                  }
                })
              })
            } else {
              console.log(res.data.msg);
              errorMsg({
                message: res.data.msg
              })
            }
          })
      },

      // 时间格式转换
      formatter(thistime, fmt) {
        let $this = new Date(thistime);
        let o = {
          'M+': $this.getMonth() + 1,
          'd+': $this.getDate(),
          'h+': $this.getHours(),
          'm+': $this.getMinutes(),
          's+': $this.getSeconds(),
          'q+': Math.floor(($this.getMonth() + 3) / 3),
          S: $this.getMilliseconds()
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(RegExp.$1, ($this.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
          }
        }
        // return fmt
        console.log(fmt);
      },
      /**
       * 查询列表
       */
      queryota() {

        var data = {
          versionType: this.searchVersionType,
          appkey: this.form.appkey,
          terminalType: this.form.terminalType,
          token: this.token,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
        api.queryota(data)
          .then(res => {
            if (res.data.code == 0) {
              this.tableData = res.data.data.otaList;
              this.totalSize = res.data.data.totalSize;
              console.log(res);
            }
          })
          .catch(err => {
            console.log("查询错误");
          });
      },
      clearParam() {
        this.form.terminalType = "";
        this.form.otaId = "";
        this.form.appkey = "";
        this.form.versionName = "";
        this.form.exversionName = '';
        this.form.fileHash = '';
        this.fileUrl = '';
        this.form.effectiveDate = '';
        this.form.publishDesc = '';
        this.form.versionDesc = '';
        this.fileList = [];
        this.form.sn = '';
        this.checked = false;
        this.form.forbidFlag = '1';
      },
      /**
       * 编辑
       */
      saveota() {
        var sn = this.form.sn;
        console.log(sn)
        var data = {
          otaId: this.form.otaId,
          versionType: this.form.versionType,
          terminalType: this.form.terminalType,
          appkey: this.form.appkey,
          versionName: this.form.versionName,
          exversionName: this.form.exversionName,
          fileHash: this.form.fileHash,
          fileUrl: this.fileUrl,
          effectiveDate: this.form.effectiveDate,
          publishDesc: this.form.publishDesc,
          versionDesc: this.form.versionDesc,
          token: this.token,
          serialNos: sn,
          forbidFlag: this.form.forbidFlag,
        }
        api.saveota(data)
          .then(res => {
            if (res.data.code == 0) {
              this.dialogFormVisible = false;
              successMsg({
                message: '添加成功'
              })
              this.clearParam();
              this.queryota();
            } else {
              errorMsg({
                message: res.data.msg
              });
            }

          })
      },
      // handleSelectionChange(val) {
      // 	this.multipleSelection = val;
      // },
      dialogVisible1() {
        this.dialogVisible = true;
        this.ids = this.multipleSelection.map(item => item.otaId);
      },
      delOta() {
        // this.ids = this.multipleSelection.map(item => item.otaId);
        this.dialogVisible = false;
        var ids = [];
        if (this.ids.length == 0) {
          ids = this.ids;
        } else {
          ids = this.ids;


          var data = {
            'ids': this.ids,
            'token': this.token
          };
          var _this = this;
          api.deleteota(data)
            .then(res => {
              if (res.data.code == 0) {
                if (this.ids.length == 0) {} else {
                  this.queryota();
                  successMsg({
                    message: '删除成功'
                  })
                }
              } else {
                errorMsg({
                  message: res.data.msg
                })
              }
            })
        }
      },
      handleChange(file, fileList) {
        this.fileList = fileList.slice(-3);
      },
      handleAvatarSuccess(res, file, fileList) {
        if (res.code == 0) {
          this.fileUrl = res.filepath;
        } else {
          errorMsg({
            message: "上传文件异常"
          })
          console.log("上传文件错误");
        }
      },

      //改变每页显示数量时调用
      handleSizeChange(val) {
        this.$nextTick(() =>
          this.queryota(),
        )
      },
      //点击下一页和点击页码时执行
      handleCurrentChange(val) {
        this.pageNo = val;
        this.queryota();
      },
      handleCurrentChangeParam(val) {
        this.pageNo = val;
        this.queryota();
      },
      //改变每页显示数量时调用  串号
      handleSizeChangeStrand(val) {
        this.$nextTick(() =>
          this.queryserialno(),
        )
      },
      //点击下一页和点击页码时执行 串号
      handleCurrentChangeStrand(val) {
        this.queryserialno();
      },

      // 版本类型 隐藏显示待升级版本
      updatedVersion() {
        this.form.exversionName = '';
        if (this.form.versionType == "2") {
          this.hide = false;
        } else if (this.form.versionType == "1") {
          this.hide = true;
        }
      },
      handleClose(done) {
        this.$confirm('没有提交，要退出吗？')
          .then(_ => {
            done();
            this.clearParam();
          })
          .catch(_ => {});
      },
      handleCloseEdit(done) {
        this.$confirm('没有保存，要退出吗？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      formatCreateDate: function(row) {
        let createDate = row.createDate;
        return window.formatDateTime(createDate);
      },
      // 11.3查询项目
      queryproduct() {
        this.form.productList = [];
        var data = {
          'pageNo': 1,
          'pageSize': 10000,
          'token': this.token
        };
        var _this = this;
        appApi.queryproduct(data)
          .then(res => {
            if (res.data.code == 0) {
              this.optionsAppKey = res.data.data.productList;
              // this.couponSelected = this.optionsAppKey[0].label;
            }
          })
      },
      downLoadFile(url) {
        var elemIF = document.createElement('iframe')
        elemIF.src = url;
        elemIF.style.display = 'none'
        document.body.appendChild(elemIF);
      },
      editOta(row) {
        console.log(row)
        this.dialogFormVisible = true;
        var eDate = window.formatDateTime(row.effectiveDate);
        this.form.otaId = row.otaId;
        this.form.versionType = row.versionType;
        this.form.terminalType = row.terminalType;
        this.form.appkey = row.appKey;
        this.form.versionName = row.versionName;
        this.form.exversionName = row.exversionName;
        this.form.fileHash = row.fileHash;
        this.fileUrl = row.fileUrl;
        this.form.effectiveDate = eDate;
        this.form.publishDesc = row.publishDesc;
        this.form.versionDesc = row.versionDesc;
        var src1 = row.serialNos.split(',');
        if (row.serialNos) {
          this.form.sn = src1.toString();
        } else {
          this.form.sn = '';
        }
        if (row.forbidFlag == '2') {
          this.checked = true;
        } else if (row.forbidFlag == '1') {
          this.checked = false;
        }

        this.form.forbidFlag = row.forbidFlag;
        // this.checked = true;
      },
      versionTypeChange() {
        this.getTerminalByAppKey(this.form.appkey);
      },
      getTerminalByAppKey(appkey) {
        var data = {
          "appkey": appkey,
          "token": this.token
        }
        appApi.queryTerminalForOta(data)
          .then(res => {
            if (res.data.code == 0) {
              this.terminalList = res.data.data.terminalList;
              this.form.terminalType = '';
            }
          })
      },
      cancelOta() {
        this.dialogFormVisible = false;
        this.clearParam();
      },
      /**
       * 获取cdn token
       */
      getCdnToken() {
        var data = {
          token: this.token
        }
        api.getCdnToken(data)
          .then(res => {
            if (res.data.code == 0) {
              this.$cookies.set('USER_CDN_TOKEN_COOKIE', res.data.data.cdntoken);
              this.cdn_token = this.$cookies.get('USER_CDN_TOKEN_COOKIE');
              this.uploadUrl = window.butelCdnUrl + '/fileupload?token=' + this.cdn_token;
              console.log(res);
            }
          })
          .catch(err => {
            console.log("查询错误");
          });
      },
    },
    created() {
      // this.token = this.$cookies.get('USER_TOKEN_COOKIE');
      this.queryota(); //查询列表
      this.queryproduct();
      this.getCdnToken();
      // this.queryserialno();
      //this.getTerminalByAppKey('');

      // let logContent = 'query ota  ';
      // let logType = 3;
      //
      // Logan.log(logContent, logType);
      // const reportResult = Logan.report({
      //   reportUrl: 'http://127.0.0.1:8080/logan-web/logan/web/upload.json',
      //   deviceId: 'ota',
      //   fromDayString: '2020-01-12',
      //   toDayString: '2020-01-15',
      //   webSource: 'Chrome',
      //   environment: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/77.0.3865.120 Safari/537.36',
      //   customInfo: JSON.stringify({userId: 123456, biz: 'Live Better'})
      // });

    },
    mounted() {

    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .meun {
    .table_border {
      overflow-y: auto;
      // height: 390px;
      overflow-x: hidden;

      .table_right_name {
        display: inline-block;
        width: 93%;
        border: 1px solid #eeeeee;
        padding: 10px 10px;

        .span {
          width: 90%;
          cursor: pointer;
          display: inline-block;
          text-overflow: ellipsis;
          /*display: -webkit-box;*/
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          float: left;
        }
      }

      .shez {
        color: #fff;
        background: #f00;
        padding: 2px;
        border-radius: 50%;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .table_left {
      width: 70%;
      float: left;
    }

    .table_right {
      width: 28%;
      float: right;
      margin-top: 44px;
      position: relative;
    }



    .crumbs {
      margin-top: 10px;
    }

    .header {
      position: relative;
      height: 60px;
      line-height: 60px;

      .paging {
        position: absolute;
        right: 0px;
        top: 10px;
      }

      .search {
        width: 120px;
      }

      .page1 {
        float: left;
        width: 45%;
        padding-left: 5%;
        // background: #f0f;
      }

      .page2 {
        float: right;
        width: 50%;
        // background: #ff0;
      }
    }

    .a {
      cursor: pointer;
    }

    .dialog-footer {
      // float: right;
    }
  }
</style>
